interface GameTab {
  id: number;
  name: string;
  gameTypes: string;
}

export const GameTabTitleComponent: GameTab[] = [
  { id: 1, name: "All Games", gameTypes: "AllGames" },
  { id: 2, name: "Slot Games", gameTypes: "SlotGames" },
  { id: 3, name: "Table Games", gameTypes: "TableGames" },
  { id: 4, name: "Casual Games", gameTypes: "CasualGames" },
];
